import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { Directive, OnDestroy } from '@angular/core';
import { ControlValueAccessor, Validator, UntypedFormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { INimbusFormControl } from '@nimbus-library/features/shared/angular/forms';

@Directive()
export class ControlValueAccessorConnector<TValue> implements ControlValueAccessor, Validator, OnDestroy {
  public control: INimbusFormControl<TValue> = new UntypedFormControl();

  public destructorSubject$: Subject<void> = new Subject();

  public validate(control: AbstractControl): ValidationErrors {
    return this.control.errors;
  }
  public registerOnValidatorChange?(fn: () => void): void {
    this.control.statusChanges.pipe(takeUntil(this.destructorSubject$)).subscribe(fn);
  }

  public registerOnTouched(fn: () => void): void {
    this.control.valueChanges.pipe(takeUntil(this.destructorSubject$), take(1)).subscribe(fn);
  }

  public registerOnChange(fn: (val: TValue) => void): void {
    this.control.valueChanges.pipe(takeUntil(this.destructorSubject$)).subscribe(fn);
  }

  public writeValue(obj: TValue): void {
    this.control.setValue(obj, { emitEvent: false });
  }

  public setDisabledState(isDisabled: boolean): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isDisabled ? this.control.disable() : this.control.enable();
  }

  public ngOnDestroy(): void {
    this.destructorSubject$.next();
    this.destructorSubject$.complete();
  }
}
